import React, { useEffect, useState } from "react";
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";

function Dashboard() {
  const [userCount, setUserCount] = useState(0);
  const [orderCount, setOrderCount] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [dailyIncome, setDailyIncome] = useState(0);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const { data: userData } = await apiClient.get(ADMIN.USER_COUNT);
        setUserCount(userData.count || 0);

        const { data: orderData } = await apiClient.get(`${ADMIN.SALES_REPORT}?filter=today`);

        setOrderCount(orderData.report.totalOrders || 0);
        setTotalSales(orderData.report.totalSales || 0);
        setDailyIncome(orderData.report.totalSales || 0);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h2>Welcome, Admin</h2>
      </div>
      <div className="row">
        {/* User Count */}
        <div className="col-xl-3 col-sm-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h3 className="mb-0">{userCount}</h3>
              <h4 className="text-success">Users</h4>
            </div>
          </div>
        </div>

        {/* Order Count */}
        <div className="col-xl-3 col-sm-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h3 className="mb-0">{orderCount}</h3>
              <h4 className="text-success">Orders Today</h4>
            </div>
          </div>
        </div>

        {/* Total Sales */}
        <div className="col-xl-3 col-sm-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h3 className="mb-0">₹{totalSales}</h3>
              <h4 className="text-success">Total Sales</h4>
            </div>
          </div>
        </div>

        {/* Daily Income */}
        <div className="col-xl-3 col-sm-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h3 className="mb-0">₹{dailyIncome}</h3>
              <h4 className="text-success">Daily Income</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
